<script>
    export default {
        props: {
            title: String,
            value: String,
            error: String,
            required: Boolean,
            maximumlength: String,
            placeholder: String
        },
        data() {
            return {
                showPassword: false
            }
        },
        methods: {
            change(val) {
                document.getElementById("password_validation").style.display = "block"
                this.$emit('input', val)
            },
            handleFocusOut() {
                document.getElementById("password_validation").style.display = "none"
            },
            handlePasswordValidation() {
                let passwordInput = document.getElementById("password")
                let letter = document.getElementById("pv_letter")
                let capital = document.getElementById("pv_capital")
                let number = document.getElementById("pv_number")
                let length = document.getElementById("pv_length")
                let special_character = document.getElementById("pv_special_character")
                let letter_flag,
                    capital_flag,
                    number_flag,
                    length_flag,
                    special_characters_flag = false

                // Validate lowercase letters
                let lowerCaseLetters = /[a-z]/g
                if(passwordInput.value.match(lowerCaseLetters)) {
                    letter.classList.remove("invalid")
                    letter.classList.add("valid")
                    letter_flag = true
                } else {
                    letter.classList.remove("valid")
                    letter.classList.add("invalid")
                    letter_flag = false
                }

                // Validate capital letters
                let upperCaseLetters = /[A-Z]/g
                if(passwordInput.value.match(upperCaseLetters)) {
                    capital.classList.remove("invalid")
                    capital.classList.add("valid")
                    capital_flag = true
                } else {
                    capital.classList.remove("valid")
                    capital.classList.add("invalid")
                    capital_flag = false
                }

                // Validate numbers
                var numbers = /[0-9]/g
                if(passwordInput.value.match(numbers)) {
                    number.classList.remove("invalid")
                    number.classList.add("valid")
                    number_flag = true
                } else {
                    number.classList.remove("valid")
                    number.classList.add("invalid")
                    number_flag = false
                }

                // Validate length
                if(passwordInput.value.length >= 8) {
                    length.classList.remove("invalid")
                    length.classList.add("valid")
                    length_flag = true
                } else {
                    length.classList.remove("valid")
                    length.classList.add("invalid")
                    length_flag = false
                }

                // Validate special_characters
                let special_characters = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g
                if(passwordInput.value.match(special_characters)) {
                    special_character.classList.remove("invalid")
                    special_character.classList.add("valid")
                    special_characters_flag = true
                } else {
                    special_character.classList.remove("valid")
                    special_character.classList.add("invalid")
                    special_characters_flag = false
                }

                if(letter_flag && capital_flag && number_flag && length_flag && special_characters_flag) {
                    document.getElementById("password_validation").style.display = "none"
                }else{
                    document.getElementById("password_validation").style.display = "block"
                }
            }
        }
    }
</script>

<template>
    <div>
        <label>
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <div class="input-group">
            <input 
                v-if="showPassword"
                type="text"
                class="form-control"
                :placeholder="placeholder"
                :value="value"
                @input="change($event.target.value)"
                :maxlength="maximumlength"
                id="password"
                @focusout="handleFocusOut"
                @keyup="handlePasswordValidation"
            />
            <input 
                v-else
                type="password"
                class="form-control"
                :placeholder="placeholder"
                :value="value"
                @input="change($event.target.value)"
                :maxlength="maximumlength"
                id="password"
                @focusout="handleFocusOut"
                @keyup="handlePasswordValidation"
            />
            <span class="input-group-text">
                <i class="fas" :class="{ 'fa-eye-slash': !showPassword, 'fa-eye': showPassword }" @click="showPassword = !showPassword"></i>
            </span>
        </div>
        <div
            v-if="error"
            class="text-danger"
            style="font-size: 80%;"
        >
            {{ error }}
        </div>
        <div id="password_validation">
            <h3>Password must contain the following:</h3>
            <p id="pv_letter" class="invalid">A <b>lowercase</b> letter</p>
            <p id="pv_capital" class="invalid">A <b>capital (uppercase)</b> letter</p>
            <p id="pv_number" class="invalid">A <b>number</b></p>
            <p id="pv_special_character" class="invalid">A <b>special character</b></p>
            <p id="pv_length" class="invalid">Minimum <b>8 characters</b></p>
        </div>
    </div>    
</template>

<style scoped>
    /* The password validation box is shown when the user clicks on the password field */
    #password_validation {
        display:none;
        background: #f1f1f1;
        color: #000;
        position: relative;
        padding: 20px;
    }

    #password_validation p {
        padding: 0px 35px;
        font-size: 12px;
    }

    /* Add a green text color and a checkmark when the requirements are right */
    .valid {
        color: green !important;
    }

    .valid:before {
        position: relative;
        left: -35px;
        content: "\2714";
    }

    /* Add a red text color and an "x" icon when the requirements are wrong */
    .invalid {
        color: red !important;
    }

    .invalid:before {
        position: relative;
        left: -35px;
        content: "\2716";
    }
</style>

